/*
  Password Gate Component for Coq Magic
  Restricts site access during testing phase
*/

import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'coq_magic_access';

// Check if already unlocked this session
const isUnlocked = () => {
    return sessionStorage.getItem(STORAGE_KEY) === 'granted';
};

// Unlock the site
const unlock = () => {
    sessionStorage.setItem(STORAGE_KEY, 'granted');
};

export default function PasswordGate({ children }) {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [unlocked, setUnlocked] = useState(isUnlocked());

    // Check on mount
    useEffect(() => {
        setUnlocked(isUnlocked());
    }, []);

    if (process.env.NODE_ENV === 'production') {
        return children;
    }

    // If no password is set in env, allow access (dev mode)
    const sitePassword = process.env.REACT_APP_SITE_PASSWORD;
    if (!sitePassword || unlocked) {
        return children;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password === sitePassword) {
            unlock();
            setUnlocked(true);
        } else {
            setError('Mot de passe incorrect');
            setPassword('');
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
            padding: 20
        }}>
            <div style={{
                background: 'rgba(255,255,255,0.05)',
                backdropFilter: 'blur(10px)',
                borderRadius: 16,
                padding: 40,
                maxWidth: 400,
                width: '100%',
                textAlign: 'center',
                border: '1px solid rgba(255,255,255,0.1)'
            }}>
                {/* Logo */}
                <div style={{
                    width: 80,
                    height: 80,
                    margin: '0 auto 24px',
                    background: 'linear-gradient(135deg, #c62828 0%, #ff5722 100%)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 32
                }}>
                    🐔
                </div>

                <h1 style={{
                    color: '#fff',
                    fontSize: 24,
                    marginBottom: 8,
                    fontWeight: 600
                }}>
                    Coq Magic
                </h1>

                <p style={{
                    color: 'rgba(255,255,255,0.6)',
                    fontSize: 14,
                    marginBottom: 32
                }}>
                    Site en phase de test - Accès restreint
                </p>

                <form onSubmit={handleSubmit}>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Mot de passe d'accès"
                        style={{
                            width: '100%',
                            padding: '14px 16px',
                            fontSize: 16,
                            border: error ? '2px solid #ef4444' : '2px solid rgba(255,255,255,0.2)',
                            borderRadius: 8,
                            background: 'rgba(255,255,255,0.1)',
                            color: '#fff',
                            outline: 'none',
                            marginBottom: 16,
                            boxSizing: 'border-box'
                        }}
                        autoFocus
                    />

                    {error && (
                        <p style={{
                            color: '#ef4444',
                            fontSize: 14,
                            marginBottom: 16
                        }}>
                            {error}
                        </p>
                    )}

                    <button
                        type="submit"
                        style={{
                            width: '100%',
                            padding: '14px 24px',
                            fontSize: 16,
                            fontWeight: 600,
                            background: 'linear-gradient(135deg, #c62828 0%, #ff5722 100%)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 8,
                            cursor: 'pointer',
                            transition: 'transform 0.2s, box-shadow 0.2s'
                        }}
                    >
                        Accéder au site
                    </button>
                </form>

                <p style={{
                    color: 'rgba(255,255,255,0.4)',
                    fontSize: 12,
                    marginTop: 24
                }}>
                    Contactez l'équipe Coq Magic pour obtenir l'accès
                </p>
            </div>
        </div>
    );
}
